import { useEffect, useMemo, useState } from "react";
import Base from "../../../Base/views/Base";
import Popup from "../../../Base/views/Popup";
import RegimeSelectionPopup from "./RegimeSelectionPopup";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Check from "@mui/icons-material/Check";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import {
  Backdrop,
  Box,
  Button,
  Chip,
  CircularProgress,
  Divider,
  Paper,
  Typography,
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import SendIcon from "@mui/icons-material/Send";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useTheme } from "@mui/material/styles";
import TDStep1 from "./TDStep1";
import TDStep2 from "./TDStep2";
import TaxSummary from "./TaxSummary";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import * as ActionTypes from "../../../../../store/Menu/ActionTypes";
import {
  GetTaxDeclarationAction,
  GetTaxEmployeeToggleInfoAction,
} from "../../../../../store/Finance/TaxDeclaration/Action";
import {
  ConvertDate,
  getUserData,
  month,
  s3Client,
} from "../../../Base/helper/baseFunctions";
import history from "../../../../../history";
import { useLocation } from "react-router-dom";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { GetObjectCommand } from "@aws-sdk/client-s3";
import { toast } from "react-toastify";
import TDStep3 from "./TDStep3";
import TDStep4 from "./TDStep4";
import TDStep5 from "./TDStep5";
const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#8b44ff",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#8b44ff",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor:
      theme.palette.mode === "dark" ? theme.palette.grey[600] : "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  color: theme.palette.mode === "dark" ? theme.palette.grey[500] : "#eaeaf0",
  display: "flex",
  height: 22,
  alignItems: "center",
  ...(ownerState.active && {
    color: "#8b44ff",
  }),
  "& .QontoStepIcon-completedIcon": {
    color: "#8b44ff",
    zIndex: 1,
    fontSize: 18,
  },
  "& .QontoStepIcon-circle": {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
};

const TaxLandingPage = () => {
  const dispatch = useDispatch();
  const { fixedMenu } = useSelector((state) => state?.MenuReducer);
  const {
    taxDeclaration_data,
    taxEmployee_toggleInfo,
    isLoading,
    isLoadingToggle,
  } = useSelector((state) => state?.FinanceReducer?.TaxDeclarationReducer);
  const location = useLocation();
  const { defaultValue, Mode } = location.state || {};

  const regimeValue = {
    agree: false,
    regime: "old_regime",
  };
  const houseObj = {
    lease_period_id: null,
    rent_from: "",
    rent_to: "",
    rent_per_month: "",
    city: "",
    lp_address: "",
    landl_name: "",
    landl_panno: "",
  };
  const housePropertyObj = {
    house_property_id: null,
    address: "",
    city: "",
    status: "",
    loan_sanc_date: "",
    lender_name: "",
    lender_type: "",
    possession_date: "",
    lender_pan: "",
    principal_amount: "",
    interest_amount: "",
  };
  const [inputData, setInputData] = useState();
  const theme = useTheme();
  const userData = getUserData();
  const [regimePopupShow, setRegimePopupShow] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [step1, setStep1] = useState({});
  const [stepUpdate1, setStepUpdate1] = useState({});
  const [step2, setStep2] = useState({});
  const [stepUpdate2, setStepUpdate2] = useState({});
  const [step3, setStep3] = useState([]);
  const [stepUpdate3, setStepUpdate3] = useState([]);
  const [step4, setStep4] = useState([]);
  const [stepUpdate4, setStepUpdate4] = useState([]);
  const [step5, setStep5] = useState({});
  const [stepUpdate5, setStepUpdate5] = useState({});
  const [comments, setComments] = useState({});
  const [regimeData, setRegimeData] = useState(regimeValue);
  const [checkViewType, setCheckViewType] = useState(false);
  const [fileProof, setFileProof] = useState({});
  const [optedDate, setOptedDate] = useState("");
  const [declarationStatus, setDeclarationStatus] = useState("");
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [checkDeclarationStatus, setCheckDeclarationStatus] = useState({});

  const steps = useMemo(() => {
    return regimeData?.regime === "old_regime"
      ? [
          "Section 80C",
          "Other Chapter VIA",
          "House Rent Exemption",
          "Section 24",
          "Other Details",
          "Summary",
        ]
      : ["Section 24B", "Summary"];
  }, [regimeData]);

  useEffect(() => {
    !fixedMenu && dispatch({ type: ActionTypes.CLOSE_MENU });
    const employee_id = defaultValue?.employee_id
      ? defaultValue?.employee_id
      : userData?.employee_id;
    dispatch(GetTaxDeclarationAction({ employee_id }));
    dispatch(GetTaxEmployeeToggleInfoAction());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (taxDeclaration_data?.[0]?.emp_tax_declaration_id) {
      const resData = taxDeclaration_data?.[0];
      const emptd = resData?.emptd?.[0];
      const emptd_approved = resData?.emptd_approved?.[0];
      setDeclarationStatus(resData?.status);
      setRegimeData({
        ...regimeData,
        regime: emptd?.preferred_regime,
      });
      setOptedDate(emptd?.submitted_Date);
      setStep1({
        et_80c_lip: emptd?.et_80c_lip,
        et_80c_ulip: emptd?.et_80c_ulip,
        et_80ccc_pension: emptd?.et_80ccc_pension,
        // et_80c_epf: emptd?.et_80c_epf,
        et_80c_ppf: emptd?.et_80c_ppf,
        et_80c_nsc: emptd?.et_80c_nsc,
        et_80c_elss: emptd?.et_80c_elss,
        et_80c_sukanya: emptd?.et_80c_sukanya,
        et_80c_fd: emptd?.et_80c_fd,
        // et_80c_scss: emptd?.et_80c_scss,
        et_80c_fees: emptd?.et_80c_fees,
        et_80c_hlp: emptd?.et_80c_hlp,
        et_80c_stamp_duty: emptd?.et_80c_stamp_duty,
        // et_80c_sa_fund: emptd?.et_80c_sa_fund,
        // et_80c_nhb: emptd?.et_80c_nhb,
        // et_80c_nabard: emptd?.et_80c_nabard,
      });
      setStep2({
        // et_80d_md: emptd?.et_80d_md,
        // et_80d_ph: emptd?.et_80d_ph,
        et_80ccd_1b_nps: emptd?.et_80ccd_1b_nps,
        et_80d_sec80d: emptd?.et_80d_sec80d,
        et_80ds_sec80ds: emptd?.et_80ds_sec80ds,
        et_80dp_sec80dp: emptd?.et_80dp_sec80dp,
        et_80dps_sec80dps: emptd?.et_80dps_sec80dps,
        et_80ddp_sec80ddb: emptd?.et_80ddp_sec80ddb,
        et_80ddbs_sec80ddbs: emptd?.et_80ddbs_sec80ddbs,
        et_80e_sec80e: emptd?.et_80e_sec80e,
        et_80dd_sec80dd: emptd?.et_80dd_sec80dd,
        et_80u_sec80u: emptd?.et_80u_sec80u,
        et_80eeb_sec80eeb: emptd?.et_80eeb_sec80eeb,
        et_80ggc_sec80ggc: emptd?.et_80ggc_sec80ggc,
      });
      setStep3(resData?.emplp?.length > 0 ? resData?.emplp : []);
      setStep4(resData?.emphp?.length > 0 ? resData?.emphp : []);
      setStep5({
        oth1: emptd?.oth1,
        oth2: emptd?.oth2,
      });
      setFileProof(resData?.file_proof);

      if (emptd_approved?.comment_approved) {
        try {
          const parsedComments =
            typeof emptd_approved?.comment_approved === "string"
              ? JSON.parse(emptd_approved?.comment_approved)
              : emptd_approved?.comment_approved;
          setComments(parsedComments?.[0]);
        } catch (error) {
          console.error("Error parsing comments:", error);
        }
      } else {
        setComments({});
      }
      setStepUpdate1({
        et_80c_lip_approved: emptd_approved?.et_80c_lip_approved,
        et_80c_ulip_approved: emptd_approved?.et_80c_ulip_approved,
        et_80ccc_pension_approved: emptd_approved?.et_80ccc_pension_approved,
        // et_80c_epf_approved: emptd_approved?.et_80c_epf_approved,
        et_80c_ppf_approved: emptd_approved?.et_80c_ppf_approved,
        et_80c_nsc_approved: emptd_approved?.et_80c_nsc_approved,
        et_80c_elss_approved: emptd_approved?.et_80c_elss_approved,
        et_80c_sukanya_approved: emptd_approved?.et_80c_sukanya_approved,
        et_80c_fd_approved: emptd_approved?.et_80c_fd_approved,
        // et_80c_scss_approved: emptd_approved?.et_80c_scss_approved,
        et_80c_fees_approved: emptd_approved?.et_80c_fees_approved,
        et_80c_hlp_approved: emptd_approved?.et_80c_hlp_approved,
        et_80c_stamp_duty_approved: emptd_approved?.et_80c_stamp_duty_approved,
        // et_80c_sa_fund_approved: emptd_approved?.et_80c_sa_fund_approved,
        // et_80c_nhb_approved: emptd_approved?.et_80c_nhb_approved,
        // et_80c_nabard_approved: emptd_approved?.et_80c_nabard_approved,
      });
      setStepUpdate2({
        // et_80d_sec80d_approved: emptd_approved?.et_80d_sec80d_approved,
        // et_80dp_sec80dp_approved: emptd_approved?.et_80dp_sec80dp_approved,
        // et_80d_md_approved: emptd_approved?.et_80d_md_approved,
        // et_80d_ph_approved: emptd_approved?.et_80d_ph_approved,

        et_80ccd_1b_nps_approved: emptd_approved?.et_80ccd_1b_nps_approved,
        et_80d_sec80d_approved: emptd_approved?.et_80d_sec80d_approved,
        et_80ds_sec80ds_approved: emptd_approved?.et_80ds_sec80ds_approved,
        et_80dp_sec80dp_approved: emptd_approved?.et_80dp_sec80dp_approved,
        et_80dps_sec80dps_approved: emptd_approved?.et_80dps_sec80dps_approved,
        et_80ddp_sec80ddb_approved: emptd_approved?.et_80ddp_sec80ddb_approved,
        et_80ddbs_sec80ddbs_approved:
          emptd_approved?.et_80ddbs_sec80ddbs_approved,
        et_80e_sec80e_approved: emptd_approved?.et_80e_sec80e_approved,
        et_80dd_sec80dd_approved: emptd_approved?.et_80dd_sec80dd_approved,
        et_80u_sec80u_approved: emptd_approved?.et_80u_sec80u_approved,
        et_80eeb_sec80eeb_approved: emptd_approved?.et_80eeb_sec80eeb_approved,
        et_80ggc_sec80ggc_approved: emptd_approved?.et_80ggc_sec80ggc_approved,
      });
      setStepUpdate3(
        resData?.emplp_approved?.length > 0 ? resData?.emplp_approved : []
      );
      setStepUpdate4(
        resData?.emphp_approved?.length > 0 ? resData?.emphp_approved : []
      );
      setStepUpdate5({
        oth1_approved: emptd_approved?.oth1_approved,
        oth2_approved: emptd_approved?.oth2_approved,
      });
    }
    if (taxDeclaration_data?.[0]?.emp_tax_declaration_id === null) {
      setRegimePopupShow(true);
    }
    setIsDataLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taxDeclaration_data]);

  const data = {
    regimeData: regimeData,
    step1: step1,
    step2: step2,
    step3: step3,
    step4: step4,
    step5: step5,
    taxDeclaration_data: taxDeclaration_data,
  };
  const updatedData = {
    regimeData: regimeData,
    stepUpdate1: stepUpdate1,
    stepUpdate2: stepUpdate2,
    stepUpdate3: stepUpdate3,
    stepUpdate4: stepUpdate4,
    stepUpdate5: stepUpdate5,
    taxDeclaration_data: taxDeclaration_data,
  };
  const [toggleState, setToggleState] = useState(
    taxEmployee_toggleInfo?.[0]?.employee_proof_upload || true
  );
  const [toggleDeclarationState, setToggleDeclarationState] = useState(false);

  const handleView = async (filename) => {
    const bucketParams = {
      Bucket: process.env.REACT_APP_DO_BUCKET_NAME,
      Key: filename,
    };
    try {
      const url = await getSignedUrl(
        s3Client,
        new GetObjectCommand(bucketParams),
        { expiresIn: 3 * 60 }
      );
      if (filename.endsWith(".doc") || filename.endsWith(".docx")) {
        window.open(
          `https://docs.google.com/viewer?url=${encodeURIComponent(
            url
          )}&embedded=true`,
          "_blank"
        );
      } else {
        window.open(url, "_blank");
      }
      return url;
    } catch (err) {
      toast.error(err);
    }
  };
  useEffect(() => {
    if (taxEmployee_toggleInfo?.[0]?.employee_proof_upload !== undefined) {
      setToggleState(taxEmployee_toggleInfo?.[0]?.employee_proof_upload);
    }
    if (taxEmployee_toggleInfo?.[0]?.tax_declaration_flag !== undefined) {
      setToggleDeclarationState(
        !taxEmployee_toggleInfo?.[0]?.tax_declaration_flag
      );
    }
  }, [taxEmployee_toggleInfo]);
  useEffect(() => {
    if (regimeData?.regime === "new_regime") {
      setActiveStep(3);
    } else if (regimeData?.regime === "old_regime") {
      setActiveStep(0);
    }

    if (declarationStatus === "Pending") {
      setCheckDeclarationStatus({ show: false, disable_ap: false });
    } else if (declarationStatus === "To be verified") {
      setCheckDeclarationStatus({ show: false, disable_ap: true });
    } else if (declarationStatus === "Action Needed") {
      setCheckDeclarationStatus({
        show: true,
        disable_ap: false,
        disable: true,
      });
    } else if (declarationStatus === "Completed") {
      setCheckDeclarationStatus({ show: true, disable_ap: true });
    }
  }, [regimeData?.regime, declarationStatus]);

  useEffect(() => {
    if (Mode) {
      setCheckViewType(true);
      setRegimePopupShow(false);
    }
  }, [defaultValue, Mode]);

  function getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return (
          <TDStep1
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            step1={step1}
            setStep1={setStep1}
            setStepUpdate1={setStepUpdate1}
            stepUpdate1={stepUpdate1}
            handleInputChange={handleInputChange}
            toggleState={toggleState}
            toggleDeclarationState={toggleDeclarationState}
            checkViewType={checkViewType}
            defaultValue={defaultValue}
            comments={comments}
            setComments={setComments}
            fileProof={fileProof}
            setFileProof={setFileProof}
            handleView={handleView}
            checkDeclarationStatus={checkDeclarationStatus}
          />
        );
      case 1:
        return (
          <TDStep2
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            step2={step2}
            setStep2={setStep2}
            stepUpdate2={stepUpdate2}
            setStepUpdate2={setStepUpdate2}
            handleInputChange={handleInputChange}
            toggleState={toggleState}
            toggleDeclarationState={toggleDeclarationState}
            checkViewType={checkViewType}
            defaultValue={defaultValue}
            comments={comments}
            setComments={setComments}
            fileProof={fileProof}
            setFileProof={setFileProof}
            handleView={handleView}
            checkDeclarationStatus={checkDeclarationStatus}
          />
        );
      case 2:
        return (
          <TDStep3
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            step3={step3}
            setStep3={setStep3}
            houseObj={houseObj}
            handleInputChange={handleInputChange}
            stepUpdate3={stepUpdate3}
            setStepUpdate3={setStepUpdate3}
            toggleState={toggleState}
            toggleDeclarationState={toggleDeclarationState}
            checkViewType={checkViewType}
            defaultValue={defaultValue}
            comments={comments}
            setComments={setComments}
            fileProof={fileProof}
            setFileProof={setFileProof}
            handleView={handleView}
            checkDeclarationStatus={checkDeclarationStatus}
          />
        );
      case 3:
        return (
          <TDStep4
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            step4={step4}
            setStep4={setStep4}
            housePropertyObj={housePropertyObj}
            handleInputChange={handleInputChange}
            stepUpdate4={stepUpdate4}
            setStepUpdate4={setStepUpdate4}
            toggleState={toggleState}
            toggleDeclarationState={toggleDeclarationState}
            regimeData={regimeData}
            checkViewType={checkViewType}
            defaultValue={defaultValue}
            updatedData={updatedData}
            comments={comments}
            setComments={setComments}
            fileProof={fileProof}
            setFileProof={setFileProof}
            handleView={handleView}
            checkDeclarationStatus={checkDeclarationStatus}
          />
        );
      case 4:
        return (
          <TDStep5
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            step5={step5}
            setStep5={setStep5}
            handleInputChange={handleInputChange}
            stepUpdate5={stepUpdate5}
            setStepUpdate5={setStepUpdate5}
            toggleState={toggleState}
            toggleDeclarationState={toggleDeclarationState}
            checkViewType={checkViewType}
            defaultValue={defaultValue}
            comments={comments}
            setComments={setComments}
            fileProof={fileProof}
            setFileProof={setFileProof}
            handleView={handleView}
            checkDeclarationStatus={checkDeclarationStatus}
          />
        );
      case 5:
        return (
          <TaxSummary
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            data={data}
            regimeData={regimeData}
            checkViewType={checkViewType}
            defaultValue={defaultValue}
            updatedData={updatedData}
            comments={comments}
            fileProof={fileProof}
            checkDeclarationStatus={checkDeclarationStatus}
            declarationStatus={declarationStatus}
          />
        );
      default:
        return "Unknown stepIndex";
    }
  }

  const handleInputChange = (event) => {
    setInputData({ ...inputData, [event.target.name]: event.target.value });
  };

  const handleBackList = () => {
    history.push("/team-tax-declaration");
  };

  return (
    <Base>
      {
        <Popup
          isMasterProduct
          fullWidth
          title="Regime Selection"
          openPopup={regimePopupShow}
          setOpenPopup={setRegimePopupShow}
          close={false}
          sx={{ marginTop: "200px" }}
        >
          <RegimeSelectionPopup
            regimeData={regimeData}
            setRegimeData={setRegimeData}
            setOpenPopup={setRegimePopupShow}
            setActiveStep={setActiveStep}
          />
        </Popup>
      }
      <Paper
        sx={{
          ".MuiDrawer-paper": {
            backgroundColor: `${
              theme.palette.mode === "dark" ? "#544166" : "white"
            }`,
          },
          borderRadius: "10px",
          paddingTop: "5px",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <Stack sx={{ width: "100%" }} direction="row">
            {checkViewType && (
              <Box sx={{ width: "110px", ml: "5px" }}>
                <Button
                  sx={{ marginRight: "10px" }}
                  type="submit"
                  variant="outlined"
                  size="medium"
                  onClick={handleBackList}
                >
                  Back to List
                </Button>
              </Box>
            )}
            <Stepper
              alternativeLabel
              activeStep={activeStep}
              connector={<QontoConnector />}
              sx={{ flexGrow: 1 }}
            >
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel StepIconComponent={QontoStepIcon}>
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </Stack>
          <Divider
            variant="middle"
            flexItem
            sx={{ paddingTop: "5px", paddingBottom: "5px" }}
          />
          {(isLoading || isLoadingToggle || isDataLoading) && (
            <div>
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={true}
              >
                <CircularProgress />
              </Backdrop>
            </div>
          )}
          <div
            style={{
              padding: "0px 30px 20px 30px",
              minHeight: "calc(100vh - 155px)",
              maxHeight: "calc(100vh - 155px)",
              overflowY: "auto",
            }}
          >
            <Box
              container
              sx={{
                justifyContent: "space-between",
                display: "flex",
                mt: 1,
                mb: 1.5,
                width: "100%",
                minWidth: "600px",
                overflowX: "auto",
                color: "black",
              }}
            >
              <Typography sx={{ color: "inherit" }}>
                Current Status:{" "}
                {regimeData?.regime === "old_regime"
                  ? "Old Regime"
                  : "New Regime"}{" "}
                Opted
              </Typography>
              {checkViewType && (
                <Typography sx={{ color: "inherit" }}>
                  Employee: {defaultValue?.employee_name}
                </Typography>
              )}
              {!checkViewType && (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography sx={{ color: "inherit" }}>Status:</Typography>
                  {getStatusChip(declarationStatus)}
                </Box>
              )}
              <Typography sx={{ color: "inherit" }}>
                Opted Date:{" "}
                {optedDate
                  ? ConvertDate(optedDate)
                  : `${String(new Date().getDate()).padStart(2, "0")} ${
                      month[new Date().getMonth()]
                    } ${new Date().getFullYear()}`}
              </Typography>
            </Box>
            <Box
              sx={{
                width: "100%",
                minWidth: "600px",
                overflowX: "auto",
                color: "black",
              }}
            >
              {getStepContent(activeStep)}
            </Box>
          </div>
        </Box>
      </Paper>
    </Base>
  );
};

export default TaxLandingPage;

const getStatusChip = (status) => {
  switch (status) {
    case "Pending":
      return (
        <Chip
          size="small"
          label="Pending!"
          style={{ backgroundColor: "#FFF4E5", color: "#FFA726" }}
        />
      );
    case "To be verified":
      return (
        <Chip
          size="small"
          icon={<SendIcon style={{ color: "#42A5F5" }} />}
          label="Submitted"
          style={{ backgroundColor: "#E3F2FD", color: "#42A5F5" }}
        />
      );
    case "Action Needed":
      return (
        <Chip
          size="small"
          icon={<ErrorOutlineIcon style={{ color: "#EF5350" }} />}
          label="Action Needed"
          style={{ backgroundColor: "#FFEBEE", color: "#EF5350" }}
        />
      );
    case "Completed":
      return (
        <Chip
          size="small"
          icon={<CheckCircleIcon style={{ color: "#66BB6A" }} />}
          label="Completed"
          style={{ backgroundColor: "#E8F5E9", color: "#66BB6A" }}
        />
      );
    default:
      return (
        <Chip
          size="small"
          label="Pending!"
          style={{ backgroundColor: "#FFF4E5", color: "#FFA726" }}
        />
      );
  }
};
